import { render } from "./SearchItem.vue?vue&type=template&id=382cc690&ts=true"
import script from "./SearchItem.vue?vue&type=script&lang=ts"
export * from "./SearchItem.vue?vue&type=script&lang=ts"

import "./SearchItem.vue?vue&type=style&index=0&id=382cc690&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__